import { ForwardedRef, forwardRef } from 'react';
import { Divider, Stack } from '@mui/material';

import { CommentType } from '@/types/Content/Comment';
import { CommentsProvider } from '../CommentContext';
import CommentSummary from '../CommentSummary/CommentSummary';
import CommentForm from '../CommentForm/CommentForm';
import CommentModals from '../CommentModal/CommentModals';
import CommentList from '../CommentList/CommentList';

export interface CommentSectionProps {
  contentId: string;
  comments?: CommentType[];
  onDelete?: (comment: CommentType) => void;
  onComment?: (comment: CommentType) => void;
  className?: string;
}

export const CommentSection = forwardRef(
  (props: CommentSectionProps, ref: ForwardedRef<HTMLDivElement>) => {
    const { contentId, comments, onComment, onDelete, className } = props;

    return (
      <CommentsProvider comments={comments} contentId={contentId}>
        <Stack spacing={3} gridArea="comments" className={className} ref={ref}>
          <CommentSummary />
          <CommentForm onComment={onComment} grayInput />
          <Divider variant="fullWidth" />
          <CommentList grayInput />
        </Stack>
        <CommentModals onDelete={onDelete} />
      </CommentsProvider>
    );
  },
);

export default CommentSection;
